import script from "./AssessmentBarriers.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentBarriers.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentBarriers.vue?vue&type=style&index=0&id=a164543a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a164543a"]])

export default __exports__